import React from 'react'
import WarningPopup from '../WarningPopup'
import { T } from 'consts/translationKeys'
import { TCanvasSizeKey } from 'consts'
import { translate } from 'utils/translations'

interface IAspectRatioWarningPopupProps {
  isOpen: boolean
  pendingSelection: TCanvasSizeKey | null
  onConfirm: () => void
  onCancel: () => void
}

const TITLE_BY_KEY: Record<TCanvasSizeKey, T> = {
  widescreen: T.SWITCH_TO_WIDESCREEN_TITLE,
  vertical: T.SWITCH_TO_VERTICAL_TITLE,
  portrait: T.SWITCH_TO_PORTRAIT_TITLE,
  square: T.SWITCH_TO_SQUARE_TITLE,
  standard: T.SWITCH_TO_STANDARD_TITLE,
  classic: T.SWITCH_TO_CLASSIC_TITLE,
  original: T.SWITCH_TO_ORIGINAL_TITLE
}

const getTitle = (pendingSelection: TCanvasSizeKey | null): string => {
  if (!pendingSelection) return translate(T.SWITCH_CANVAS_SIZE_TITLE)
  return translate(TITLE_BY_KEY[pendingSelection])
}

const AspectRatioWarningPopup: React.FC<IAspectRatioWarningPopupProps> = ({
  isOpen,
  pendingSelection,
  onConfirm,
  onCancel
}) => {
  return (
    <WarningPopup
      isOpen={isOpen}
      title={getTitle(pendingSelection)}
      warningText={
        <>
          <strong>Note:</strong>{' '}
          {translate(T.ASPECT_RATIO_WARNING_DESCRIPTION)
            .replace('Note:', '')
            .trim()}
        </>
      }
      confirmButtonText={translate(T.SWITCH_LABEL)}
      cancelButtonText={translate(T.CANCEL_LABEL)}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}

export default AspectRatioWarningPopup
